import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {BulkUploadSupportedField, BulkUploadSupportedValuesTip} from './bulk-upload-supported-values.model';

@Component({
    selector: 'app-bulk-upload-supported-values',
    imports: [CommonModule],
    templateUrl: './bulk-upload-supported-values.component.html',
    styleUrl: './bulk-upload-supported-values.component.css',
})
export class BulkUploadSupportedValuesComponent {
    @Input() title = 'Supported Values';
    @Input() fields: BulkUploadSupportedField[] = [];
    @Input() tip?: BulkUploadSupportedValuesTip | string;

    isStructuredTip(tip: BulkUploadSupportedValuesTip | string): tip is BulkUploadSupportedValuesTip {
        return typeof tip !== 'string';
    }
}
